import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "src/context/authContext";
import publicLogo from "../images/logos/PublicMobile-sand.svg";
import publicMobile from "../images/logos/PublicMobile-apricot.svg";
import { Box, StackView, Typography, Select } from "@telus-uds/components-base";
import { useState, useEffect } from "react";
import {getUserLanguageFromBrowser} from "src/Utilities/language";

function Header() {
  const { isCommunity, setUserLanguage, userLanguage } = useAuthContext();
  const currURL = window.location.href;

  const navigate = useNavigate();
  const location = useLocation();

  const [selectedLanguage, setSelectedLanguage] = useState(userLanguage);
  const items = [
    {
      label: "English",
      id: "EN",
    },
    {
      label: "Français",
      id: "FR",
    },
  ];

  //console.log("SET USER LANGUAGE");

  function updateURLParameter(url, param, paramVal) {
    let newAdditionalURL = "";
    let tempArray = url.split("?");
    let baseURL = tempArray[0];
    let additionalURL = tempArray[1];
    let temp = "";
    if (additionalURL) {
      tempArray = additionalURL.split("&");
      for (let i = 0; i < tempArray.length; i++) {
        if (tempArray[i].split("=")[0] != param) {
          newAdditionalURL += temp + tempArray[i];
          temp = "&";
        }
      }
    }
    let rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
  }

  /*useEffect(() => {

    const queryParams = new URLSearchParams(location.search);
    queryParams.set("locale", userLanguage);


    console.log("query params: " , queryParams.toString());
    console.log("current URL" , currURL);
    
    navigate({
      search: `?${queryParams.toString()}`
    });

  }, [userLanguage]);*/

  setUserLanguage(getUserLanguageFromBrowser());
  const changeHandler = (e) => {
    const newLanguage = e.target.value.toLowerCase();

    setUserLanguage(e.target.value.toLowerCase());
    sessionStorage.setItem("userLanguage", newLanguage);
    localStorage.setItem("userLanguage", newLanguage);

    //window.location.reload();
    window.location.replace(
      updateURLParameter(currURL, "locale", e.target.value.toLowerCase())
    );
  };

  // useEffect(() => {
  //   if (!window.location.search) {
  //     window.location.replace(
  //       updateURLParameter(currURL, "locale", userLanguage)
  //     );
  //   }
  // }, []);

  return (
    <Box variant={{ background: "brand" }} space={4}>
      <StackView
        direction="row"
        tokens={{
          alignItems: "center",
          justifyContent: "space-between",
          flexGrow: 1,
        }}
        //value={items[0].id.toLocaleLowerCase() === userLanguage ?? false}
        onChange={changeHandler}
      >
        <img
          src={isCommunity ? publicLogo : publicMobile}
          id="logoImg"
          className="w-32 px-[10px] py-5"
        />
        {isCommunity ? (
          <Typography variant={{ size: "large", inverse: true }}>
            Community
          </Typography>
        ) : null}
        <select
          id="input-1"
          aria-describedby=""
          aria-invalid="false"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0)",
            color: "#F39D80",
            fontWeight: "bold",
            borderWidth: "1px",
            borderColor: "rgba(0, 0, 0, 0)",
            borderRadius: "4px",
            padding: "3px",
            marginRight: "10px",
            height: "28px",
            appearance: "none",
            outline: "none",
            backgroundImage: "none",
          }}
          // value={items[0].id.toLocaleLowerCase() === userLanguage ?? false}
          onChange={(e) => changeHandler(e)}
        >
          {items.map((item, idx) => (
            <option
              value={item.id}
              key={idx}
              selected={item.id.toLocaleLowerCase() === userLanguage ?? false}
            >
              {item.id}
            </option>
          ))}
        </select>
        {/* <Select
          aria-describedby=""
          aria-invalid="false"
          onChange={(e) => changeHandler(e)}
          initialValue={selectedLanguage.toLowerCase()}
        >
          {items.map((item, idx) => (
            <Select.Item value={item.id} key={idx}>
              {item.id}
            </Select.Item>
          ))}
        </Select> */}
      </StackView>
    </Box>
  );
}

export default Header;
